import { createRequest, RequestConfig } from 'app/common/api';

import { TNewTariff } from '../core/tariff';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/update_tariff_details',
};

export const updateTariffDetailsRequest = (tariffs: TNewTariff[]) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(tariffs),
  });
